var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row green-fitout__entry" },
    [
      _c(
        "div",
        { staticClass: "small-12" },
        [
          _vm.isTenant && !_vm.isStarted
            ? _c("div", { staticClass: "tenant-not-start hint" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t("tenantProjects.greenFitOut.tenantStatHint")
                    ) +
                    "\n    "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("GreenFitOutActionBtns"),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isStarted
        ? [
            _c("div", { staticClass: "small-6" }, [
              _c(
                "div",
                { staticClass: "green-fitout__left" },
                [
                  _c("GreenFitOutFolders"),
                  _vm._v(" "),
                  _c("GreenFitOutRemarks"),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "small-6" }, [
              _c(
                "div",
                { staticClass: "green-fitout__right" },
                [_c("GreenFitOutSubTabs")],
                1
              ),
            ]),
          ]
        : _c(
            "div",
            { staticClass: "small-12" },
            [_c("GreenFitOutGuideline")],
            1
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }